













































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppAutoComplete extends Vue {
  @Prop({ type: Array }) readonly value!: string[];
  @Prop(String) readonly label!: string;
  @Prop({ type: String }) readonly placeholder!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: [Number, String], default: '289' }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  @Prop({ type: String }) readonly confirm!: string;
  @Prop({ type: Boolean, default: false }) readonly autofocus!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Array }) readonly items!: string[];

  model: string[] = [];

  showPWD = false;

  rules = {
    required: (value: string) => !!value || '不能为空！',
    text: () => true
  };

  mounted () {
    this.model = this.value
  }

  remove (item: string) {
    const index = this.value.indexOf(item)
    if (index >= 0) this.model.splice(index, 1)
  }

  @Watch('model')
  onModelChanged () {
    this.valueChangedHandler()
  }

  @Emit('input')
  valueChangedHandler () {
    return this.model
  }
}
